import { connectedStore } from '../../store';
import selectors from '../selectors';

const applyInjection = (injectionName, element) => {
  const store = connectedStore.get();
  let mutatedDom;

  if (!store) return element;
  const state = store.getState();

  const extensions = selectors.getExtensions(state);

  if (!extensions) return element;

  extensions.forEach((extension) => {
    if (extension.injections && typeof extension.injections[injectionName] !== 'undefined') {
      mutatedDom = extension.injections[injectionName](element);
    }
  });

  return mutatedDom || element;
};

export default applyInjection;
